import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import metadata from './ProjectSpecificCglComponent.metadata.json5';

import styles from "../BuildersRisk.module.scss";
import AdjacentStructionsComponent from '../SubComponents/AdjacentStructions/AdjacentStructionsComponent';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function ProjectSpecificCglComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('ProjectSpecificCglComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true

    const isSmallCOCResidential = () => !_.isUndefined(submissionVM.value.lobData.consTraAndServLine.coverables.buildersRisk.productCoveragesSelection.typofInsReqFie)
                            && submissionVM.value.lobData.consTraAndServLine.coverables.buildersRisk.productCoveragesSelection.typofInsReqFie === 'SmaResCOC'

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        adjacentStructionsComponent:{
            data: modelVM.adjacentStructions,
            updateWizardData,
            submissionVM,
            AdjacentStructionsPath: `${pathUpdated}.adjacentStructions`
        },
        areallempcovbyWCBFie: {
            visible: isSmallCOCResidential()
        },
        ifnopleexpFie: {
            visible: isSmallCOCResidential() && !_.isUndefined(modelVM.areallempcovbyWCBFie.value) && !modelVM.areallempcovbyWCBFie.value
        },
        occofexistrdurconFie: {
            visible: isSmallCOCResidential()
        },
        maninwhistrwilconocomFie: {
            visible: isSmallCOCResidential() && !_.isUndefined(modelVM.doetheproatttoorcostrFie) && modelVM.doetheproatttoorcostrFie.value === true
        },
        doetheproatttoorcostrFie: {
            visible: isSmallCOCResidential()
        },
        ifdemblapildrishoaproFie: {
            visible: isSmallCOCResidential()
        },
        istheshoundorpildrinvFie: {
            visible: isSmallCOCResidential()
        },
        shoundorpildrinatoactFie: {
            visible: isSmallCOCResidential() && !_.isUndefined(modelVM.istheshoundorpildrinvFie) && modelVM.istheshoundorpildrinvFie.value === true
        },
        shoundorpildriconppriFie: {
            visible: isSmallCOCResidential() && !_.isUndefined(modelVM.istheshoundorpildrinvFie) && modelVM.istheshoundorpildrinvFie.value === true
        },
        shoundorpildridurFie: {
            visible: isSmallCOCResidential() && !_.isUndefined(modelVM.istheshoundorpildrinvFie) && modelVM.istheshoundorpildrinvFie.value === true
        },
        shoundorpildrireltstrFie: {
            visible: isSmallCOCResidential() && !_.isUndefined(modelVM.istheshoundorpildrinvFie) && modelVM.istheshoundorpildrinvFie.value === true
        },
        ifNOpleexp2Fie: {
            visible: !_.isUndefined(modelVM.wiltheprobeincomwirecFie.value) && !modelVM.wiltheprobeincomwirecFie.value   
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            adjacentStructions: AdjacentStructionsComponent
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

ProjectSpecificCglComponent.propTypes = wizardProps;
export default withRouter(ProjectSpecificCglComponent);
